import { useEffect } from 'react';

function Modal({ children, onClose, title, headerActions, className = '' }) {
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };

        document.addEventListener('keydown', handleEscape);
        document.body.style.overflow = 'hidden';

        return () => {
            document.removeEventListener('keydown', handleEscape);
            document.body.style.overflow = 'auto';
        };
    }, [onClose]);

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="modal-overlay" onClick={handleBackdropClick}>
            <div className={`modal-content ${className}`}>
                <div className="modal-header">
                    <div className="modal-header-content">
                        {title && <h2 className="modal-title">{title}</h2>}
                        <button
                            onClick={onClose}
                            className="modal-close"
                            aria-label="Close modal"
                        >
                            ×
                        </button>
                    </div>
                    {headerActions && (
                        <div className="modal-header-actions">
                            {headerActions}
                        </div>
                    )}
                </div>
                <div className="modal-body">
                    {children}
                </div>
            </div>
        </div>
    );
}

export default Modal;
